export function VANHeadCompose(page, rowL, ll, dataUrl) {
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;

    var imageX = 145;

    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 50, 20);
    _y += _space;

    return _y;
}

export function VANBodyContentCompose(page, rowL, ll, data) {
    // console.log("data", data)
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;
    const margin = 10;
    if(data && data.length > 0){
        doc.setFont("times", "bold");
        doc.text('VESSEL ARRIVAL NOTICE', 110, _y, null, null, 'center');
        doc.setFont("times", "normal");
        _y += _space * 2.5;

        //headers
        doc.text(margin, _y, `Vessel: ${data[0].vessel}`);
        let current_datetime = new Date()
        let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear();
        doc.text(130, _y, 'Date: ' + formatted_date);
        _y += _space;
        doc.text(margin, _y, 'Voyage Sequence: ' + data[0].voyage);
        doc.text(130, _y, 'Voyage Reference: ' + data[0].voyageRef);
        _y += _space * 2;
    
        doc.text(margin, _y, 'Port of Origin:');
        doc.text(60, _y, data[0].origin ? data[0].origin : '');
        doc.line(60, _y + 1, 120, _y + 1);
    
        let Arrival_datetime = new Date(data[0].actualTimeDeparture)
        let Arrivalformatted_date = (Arrival_datetime.getMonth() + 1) + "/" + Arrival_datetime.getDate() + "/" + Arrival_datetime.getFullYear();
        doc.text(130, _y, 'ATD:');
        doc.text(140, _y, Arrivalformatted_date);
        doc.line(140, _y + 1, 200, _y + 1);
    
        _y += _space;
        doc.text(margin, _y, 'Port of Destination:');
        doc.text(60, _y, data[0].destination ? data[0].destination : '');
        doc.line(60, _y + 1, 120, _y + 1);
    
        // let Esti_datetime = new Date(data[0].etd)
        // let Estiformatted_date = (Esti_datetime.getMonth() + 1) + "/" + Esti_datetime.getDate() + "/" + Esti_datetime.getFullYear();
        doc.text(130, _y, `ATA:`);
        // doc.text(140, _y, Estiformatted_date);
        doc.line(140, _y + 1, 200, _y + 1);
        _y += _space * 2;
    
        doc.text(margin, _y, 'Shipper:');
        doc.text(60, _y, data[0].shipper ? data[0].shipper : '');
        doc.line(60, _y + 1, 200, _y + 1);
    
        if(data && data[0].shipperPreferedName){
            _y += _space;
            doc.text(margin, _y, 'Shipper Preferred Name:');
            doc.text(60, _y, data[0].shipperPreferedName ? data[0].shipperPreferedName : '');
            doc.line(60, _y + 1, 200, _y + 1);
        }
    
        _y += _space;
        doc.text(margin, _y, 'Consignee:');
        doc.text(60, _y, data[0].consigneeName ? data[0].consigneeName : '');
        doc.line(60, _y + 1, 200, _y + 1);
    
        if(data && data[0].consigneePreferedName){
            _y += _space;
            doc.text(margin, _y, 'Consignee Preferred Name:');
            doc.text(65, _y, data[0].consigneePreferedName ? data[0].consigneePreferedName : '');
            doc.line(65, _y + 1, 200, _y + 1);        
        }
    
        _y += _space * 2;
    
        doc.text(margin, _y, 'NO.');
        doc.text(margin * 1.7, _y, 'BOOKING');
        doc.text(margin * 3.5, _y, 'WAYBILL REF');
        doc.text(margin * 6.0, _y, 'MOD');
        doc.text(margin * 7.1, _y, 'MOP');
        doc.text(margin * 8.0, _y, 'CONTAINER VAN #');
        doc.text(margin * 11.5, _y, 'SEAL NO.');
        doc.text(margin * 13.6, _y, 'CARGO');
        doc.text(margin * 17.4, _y, 'RELEASE TYPE');
        doc.line(margin, _y + 1, 200, _y + 1);
        _y += _space;
    
        data.forEach((element, id) => {
            doc.text(margin, _y, (id + 1).toString());
            doc.text(margin * 1.7, _y, element.bookingRef ? element.bookingRef : '');
            doc.text(margin * 3.5, _y, element.wayBillRef ? element.wayBillRef : '');
            doc.text(margin * 6.0, _y, element.modeOfDelivery ? element.modeOfDelivery : '');

            var mop = "";
            if(element.modeOfPayment === "Prepaid"){ mop = "P";}
            else if(element.modeOfPayment === "Collect"){ mop = "C";}
            else if(element.modeOfPayment === "Account Origin"){ mop = "AO";}
            else if(element.modeOfPayment === "Account Destination"){ mop = "AD";}

            doc.text(margin * 7.1, _y, mop);
            doc.text(margin * 8.0, _y, element.cargo ? element.cargo : '');
            doc.text(margin * 11.5, _y, element.sealNum ? element.sealNum : '');
          
            // var splitMargin = (200) - (margin * 16);
            var splitMargin = (margin * 17.4) - (margin * 13.6);
            var splitGoods = doc.splitTextToSize(element.goods ? element.goods : '', splitMargin);
            doc.text(margin * 13.6, _y, splitGoods);
    
            let releasetype = "";
            if(element.modeOfDelivery === "PTP" || element.modeOfDelivery === "DTP"){
                if(element.isStripping){
                    if(element.strippingType === "011") {
                        releasetype = "CY Stripping Mano";
                    }
                    else if(element.strippingType === "010") {
                        releasetype = "CY Stripping Area";
                    }
                    else if(element.strippingType === "ALL") {
                        releasetype = "CY Stripping Area and CY Stripping Mano";
                    }
                }
                else {
                    releasetype = "Van Out";
                }
            }
            var releaseSplitMargin = (200) - (margin * 17.4);
            var splitRelease = doc.splitTextToSize(releasetype, releaseSplitMargin);
            doc.text(margin * 17.4, _y, splitRelease);

            if (splitGoods.length > 1) {
                if (splitRelease.length > 1 && splitRelease.length > splitGoods.length) {
                    _y += (_space * splitRelease.length);
                }
                else {
                    _y += (_space * splitGoods.length);
                }
            }
            else {
                if (splitRelease.length > 1) {
                    _y += (_space * splitRelease.length);
                }
                else {
                    _y += _space;
                }
            }
    
            if (_y > 275) {
                doc.addPage(page.layout, page.papersize.unit, page.papersize.format);
                _y = 10;
                // doc.text(margin, _y, 'NO.');
                // doc.text(margin * 1.8, _y, 'BOOKING REF');
                // doc.text(margin * 4.5, _y, 'WAYBILL REF');
                // doc.text(margin * 7.5, _y, 'MOD');
                // doc.text(margin * 8.5, _y, 'MOP');
                // doc.text(margin * 9.5, _y, 'CONTAINER VAN #');
                // doc.text(margin * 13.5, _y, 'SEAL NO.');
                // doc.text(margin * 16.5, _y, 'CARGO');
                // doc.line(margin, _y + 1, 200, _y + 1);

                doc.text(margin, _y, 'NO.');
                doc.text(margin * 1.7, _y, 'BOOKING');
                doc.text(margin * 3.5, _y, 'WAYBILL REF');
                doc.text(margin * 6.0, _y, 'MOD');
                doc.text(margin * 7.1, _y, 'MOP');
                doc.text(margin * 8.0, _y, 'CONTAINER VAN #');
                doc.text(margin * 11.5, _y, 'SEAL NO.');
                doc.text(margin * 13.6, _y, 'CARGO');
                doc.text(margin * 17.4, _y, 'RELEASE TYPE');
                doc.line(margin, _y + 1, 200, _y + 1);
                _y += _space;
                
            }
        });
        _y -= _space;
        doc.line(margin, _y + 1, 200, _y + 1);
    
        _y += _space * 2;
    
        doc.text(margin, _y, 'Remarks:');
        _y += _space;

        // let remarkList = [];
        // data.forEach(element => {
        //     if(element.remarks && element.remarks !== ""){
        //         remarkList.push("BookRef: " + element.bookingRef + " - " + element.remarks); 
        //     }
        // })
        // let reMark = remarkList.join(', ');
        // let remark = doc.splitTextToSize(reMark ? reMark : '', 190);
    
        // doc.text(margin, _y, remark ? remark : '');
        // if(remark.length > 1){
        //     for (let x = 0; x < remark.length; x++) {
        //         doc.line(margin, _y + 1, 200, _y + 1);
        //         _y += (_space * 0.8);
        //     }
        //     _y -= _space;
        // }
        // else {
            doc.line(margin, _y + 1, 200, _y + 1);
        // }

        // doc.text(margin, _y, data[0].remarks ? data[0].remarks : '');
        // doc.line(margin, _y + 1, 200, _y + 1);
        // _y += _space;
        // doc.line(margin, _y + 1, 200, _y + 1);
    }


    return _y
}